export const getRectLowerBound = (rect: ClientRect) => rect.top + rect.height;
